import { FORGOT_PASSWORD_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import forgotPasswordSchema from 'root/src/shared/descriptions/formSchemas/forgotPasswordSchema'

export default {
	[FORGOT_PASSWORD_FORM_MODULE_ID]: {
		moduleType: 'form',
		schema: forgotPasswordSchema,
		formSubmitErrorMessages: [
			{
				errorType: 'code',
				errorCode: 'InvalidParameterException',
				errorMessage: 'Cannot reset password for the user as there is no registered/verified email or phone_number',
			},
			{
				errorType: 'code',
				errorCode: 'UserNotFoundException',
				errorMessage: 'Email not found',
			},
		],
		title: 'Reset Password',
		fields: [
			{
				fieldId: 'email',
				inputType: 'email',
				label: 'Email',
			},
		],
		submits: [
			{ label: 'Reset Password' },
		],
	},
}
